<template>
    <v-container>
        <v-row v-if="!editing">
            <v-toolbar dense flat color="transparent">
                <v-btn color="grey" text small dark v-if="allowEditing" @click="updateNightly">
                    <v-icon v-if="pack.nightly"> mdi-refresh </v-icon>
                    <v-icon v-if="!pack.nightly"> mdi-hand-right </v-icon>
                </v-btn>
                <a @click="editValue" v-text="title" v-bind="$props" />
            </v-toolbar>
        </v-row>
        <v-row v-if="editing">
            <v-col>
                <v-card flat>
                    <v-card-text>
                        <v-text-field
                            :label="$t('packs.attributes.label')"
                            v-if="editing"
                            v-model="editingValue"
                            single-line
                            counter="80"
                        ></v-text-field>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red" text @click="editing = false" v-text="$t('buttons.cancel')" />
                        <v-btn color="success" text @click="changeAttribute" v-text="$t('buttons.save')" />
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    name: 'pack-label',
    data: () => ({
        editing: false,
        editingValue: undefined,
    }),
    props: {
        pack: {},
        allowEditing: {
            default: true,
        },
    },
    watch: {
        editing: function (e) {
            if (e) {
                this.editingValue = this.pack.label;
            }
        },
    },
    computed: {
        title() {
            return this.pack.label;
        },
    },
    methods: {
        ...mapActions(['updatePack']),
        editValue() {
            if (this.allowEditing) {
                this.editing = true;
            }
        },
        async updateNightly() {
            await this.updatePack({
                id: this.pack.id,
                nightly: !this.pack.nightly,
            });

            this.$emit('change-attribute-value');
        },
        async changeAttribute(value) {
            await this.updatePack({
                id: this.pack.id,
                label: this.editingValue,
            });

            this.editing = false;
            this.$emit('change-attribute-value');
        },
    },
};
</script>
